import {createAction} from '@reduxjs/toolkit'

import type {AgentId} from '../../../types'

export const markAgentDeleted = createAction<AgentId>('markAgentDeleted')
